export const DESIGN_TYPE_OPTIONS = [
    { name: '创意', value: 1 },
    { name: '模板', value: 0 },
];
